module.exports = {
  description: 'generate new Variant Storybook story',
  prompts: [
    {
      type: 'input',
      name: 'baseName',
      message: 'base name please'
    },
    {
      type: 'input',
      name: 'variantName',
      message: 'variant name please'
    },
  ],
  actions: (): import('plop').ActionType[] => {
    const rootTemplatePath = 'app/javascript/components/plop/templates/base-variant-component';
    const rootDestinationPath = 'app/javascript/components/library/{{kebabCase baseName}}';

    const actions = [
      {
        destination: `${rootDestinationPath}/stories`,
        base: `${rootTemplatePath}/stories-files`,
        templateFiles: `${rootTemplatePath}/stories-files/*.hbs`,
      },
    ];

    return actions.map(({ base, destination, templateFiles }) => ({
      type: 'addMany',
      destination,
      base,
      templateFiles,
    }));
  },
};
